import { render, staticRenderFns } from "./ReportAddDialog.vue?vue&type=template&id=21852356"
import script from "./ReportAddDialog.vue?vue&type=script&lang=js"
export * from "./ReportAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports